import React, { Component } from 'react'
import PermissionsCheck from '../../auth/components/PermissionsCheck'
import { PERMS } from '../permissions'
import { dateFormatter, datePeriodFormatter, numberFormatter } from "../../../common/formatters";

class ServiceOrdersListRow extends Component {
    handleClick = e => {
        e && e.preventDefault()
        e && e.stopPropagation()

        this.props.onClick(this.props.data.id)
    }

    handleDelete = e => {
        e && e.preventDefault()
        e && e.stopPropagation()

        this.props.onDelete(this.props.data.id)
    }

    render = () => (
        <tr onClick={this.handleClick} className="row-selectable">
            <PermissionsCheck hasAny={[PERMS.UPDATE, PERMS.DELETE]}>
                <td className="w-60 table-buttons">
                    <PermissionsCheck has={[PERMS.UPDATE]}>
                        <button className="far fa-pencil text-gray m-r-xxs" />
                    </PermissionsCheck>
                    <PermissionsCheck has={[PERMS.DELETE]}>
                        <button onClick={this.handleDelete} className="far fa-trash text-gray" />
                    </PermissionsCheck>
                </td>
            </PermissionsCheck>
            <td className="w-160 text-center">
                {datePeriodFormatter(this.props.data.date_planned_from, this.props.data.date_planned_to)}
            </td>
            <td className="w-140">
                {this.props.state ? this.props.state.name : ''}
            </td>
            <td className="w-100">
                {this.props.vehicle ? this.props.vehicle.registration : ''}
            </td>
            <td className="w-100">
                {this.props.trailer ? this.props.trailer.registration : ''}
            </td>
            <td className="w-400">
                {this.props.customer ? this.props.customer.name : ''}
            </td>
            <td className="w-max wm-300">
                {this.props.data.text}
            </td>
        </tr>
    )
}

export default ServiceOrdersListRow
